module.exports = __webpack_public_path__ + "img/kr.2f80d5ec.svg";